/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./tabLoading.vue?vue&type=template&id=0e6923ba&scoped=true"
var script = {}
import style0 from "./tabLoading.vue?vue&type=style&index=0&id=0e6923ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e6923ba",
  null
  
)

export default component.exports